import { Card, Box, Typography } from '@mui/material';
import { Control } from 'react-hook-form';
import ByocInboundSipTrunkForm from '../ByocInboundSipTrunkForm';
import ByocOutboundSipTrunkForm from '../ByocOutboundSipTrunkForm';
import { InboundSipTrunkResponse } from 'apis/business/agent/deployPhone/inboundSipTrunk/types';
import { OutboundSipTrunkResponse } from 'apis/business/agent/deployPhone/outBoundSipTrunk/types';
import Switch from 'components/Common/Switch';

type SipTrunkingConfigProps = {
  control: Control<any>;
  inboundConfigured: boolean;
  outboundConfigured: boolean;
  inboundFormData: InboundSipTrunkResponse | undefined;
  outboundFormData: OutboundSipTrunkResponse | undefined;
  selectedProvider: string;
  selectedProviderId?: number;
  deleteInboundFormData: () => void;
  deleteOutboundFormData: () => void;
  persistInbound?: (payload: InboundSipTrunkResponse) => Promise<void>;
  persistOutbound?: (payload: OutboundSipTrunkResponse) => Promise<void>;
};

export default function SipTrunkingConfig({
  control,
  inboundConfigured,
  outboundConfigured,
  inboundFormData,
  outboundFormData,
  selectedProvider,
  selectedProviderId,
  deleteInboundFormData,
  deleteOutboundFormData,
  persistInbound,
  persistOutbound
}: SipTrunkingConfigProps) {
  return (
    <>
      <Card variant='outlined' sx={{ mb: 2, border: '1px solid #ececec', borderRadius: 1 }}>
        <Box p={2}>
          <Box
            display='flex'
            flexDirection={{ xs: 'column', sm: 'row' }}
            justifyContent='space-between'
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            marginBottom={inboundConfigured ? 3 : 0}
            gap={{ xs: 1.5, sm: 0 }}
          >
            <Box>
              <Typography fontSize={16} fontWeight={500}>
                Inbound Configuration (Origination)
              </Typography>
              <Typography fontSize={14} color='#777'>
                Configure incoming calls
              </Typography>
            </Box>
            <Switch
              control={control}
              name='inbound_configured'
              onToggle={(checked) => {
                if (!checked && inboundFormData?.id) deleteInboundFormData();
              }}
            />
          </Box>
          {inboundConfigured && (
            <ByocInboundSipTrunkForm
              inboundFormData={inboundFormData}
              selectedProvider={selectedProvider}
              telephonyProviderId={selectedProviderId}
              persist={persistInbound}
            />
          )}
        </Box>
      </Card>
      <Card variant='outlined' sx={{ mb: 2, border: '1px solid #ececec', borderRadius: 1 }}>
        <Box p={2}>
          <Box
            display='flex'
            flexDirection={{ xs: 'column', sm: 'row' }}
            justifyContent='space-between'
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            gap={{ xs: 1.5, sm: 0 }}
          >
            <Box>
              <Typography fontSize={16} fontWeight={500}>
                Outbound Configuration (Termination)
              </Typography>
              <Typography fontSize={14} color='#777'>
                Configure outgoing calls
              </Typography>
            </Box>
            <Switch
              control={control}
              name='outbound_configured'
              onToggle={(checked) => {
                if (!checked && outboundFormData?.id) deleteOutboundFormData();
              }}
            />
          </Box>
          {outboundConfigured && (
            <ByocOutboundSipTrunkForm
              selectedProvider={selectedProvider}
              outboundFormData={outboundFormData}
              telephonyProviderId={selectedProviderId}
              persist={persistOutbound}
            />
          )}
        </Box>
      </Card>
    </>
  );
}
